<template>
  <div id="app"
       :class="{ 'dark_mode': loginStore.theme === 'dark' }">
    <RouterView/>
  </div>
</template>
<script setup>

import {useLoginStore} from "./menu/context/stores/loginStore";
import {onMounted} from "vue";
import {useAuth0} from "@auth0/auth0-vue"
import {initializeApi} from "@/shared/axios";
import {useMenuItemStore} from "@/menu/context/stores/menuItemStore";

const loginStore = useLoginStore()
const menuItemStore = useMenuItemStore()
const {getAccessTokenSilently} = useAuth0()

const initializeConfig = () => {
  loginStore.initializeConfig()
  menuItemStore.initializeConfig()
}

onMounted(() => {
  initializeApi(getAccessTokenSilently)
  initializeConfig()
  loginStore.pageLoadedORRefreshed()
  if (loginStore.theme === null) {
    loginStore.updateStateValue('theme', 'light')
  }
})
</script>
